import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { graphql } from 'react-apollo';
import { currentUserQuery } from '../queries';

class RedirectRouteCompleteRegistration extends React.Component {

  render() {
    const { component: Component, data: {loading, error, currentUserContext }, client, ...rest } = this.props;
    this.props.data.refetch();
    return (
      <div>
        { (!loading && !error) &&
        <Route
          {...rest}
          render={props =>
            ((currentUserContext.uid === 0 || currentUserContext.fieldVatNumber)
                ? <Redirect to="/"/>
                : <Component currentUser={currentUserContext} client={client} {...props} />
            )}
        />
        }
      </div>)
  };
};

export default graphql(
  currentUserQuery, {
  options: { fetchPolicy: 'network-only' },
})(RedirectRouteCompleteRegistration);


// WEBPACK FOOTER //
// ./src/utils/RedirectRouteCompleteRegistration.js